import { Component, OnInit, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { SessionTokenService } from '../../../components/common/utils/sessionToken.service';
import { HandleError } from '../../../components/common/utils/handleError.component';
import { UtilService } from '../../../components/common/utils/util.service';
import { SiniestrosService } from '../siniestros.service';
import { ClienteXCiudad, ClienteLogin } from '../../login/cliente_login';
import { UsuarioLoginEntity } from '../../login/usuario_login_entity';
import { VehiculoEntity } from '../../masivos/datosGenerales/entities/vehiculo_entity';
import { CalendarFec } from '../../../components/common/utils/calendarFechaNacParametros';
import { CiudadEntity } from '../../../components/common/utils/entities/especificacionesVehiculo';
import { DatosSiniestro } from '../siniestros_entity';


const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'reporte-siniestros-vehiculos',
    templateUrl: 'siniestro-reporte-vehiculo.template.html',
    providers: [SiniestrosService]
})
export class RerporteSiniestroVehiculoComponent extends CalendarFec implements OnInit {
    usuario: ClienteLogin;
    usuarioLogin: UsuarioLoginEntity;
    showLoader: string;
    userEmpresa: ClienteXCiudad;
    totalPrima: number = 0;
    totalPendientes: number = 0;
    totalValorReserva: number = 0;
    totalCerrados: number = 0;
    totalValorIndemnizado: number = 0;
    totalSiniestralidad: number = 0;
    filterQuery: string;
    filterQuery1: string;
    ramos: string[];
    polizas: string[];

    datosSiniestro: DatosSiniestro = new DatosSiniestro();

    fechaIncidente: Date;
    ciudades: CiudadEntity[];
    ciuIncidente: string = "";

    showLoader2: string = "";

    @Input()
    vehiculo: VehiculoEntity

    constructor(
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService,
        public utilsService: UtilService,
        public siniestrosService: SiniestrosService) {
        super();
        this.userEmpresa = new ClienteXCiudad();
        this.usuario = new ClienteLogin();
        this.ramos = new Array<string>();
        this.filterQuery = "";
        this.filterQuery1 = "";
        this.polizas = new Array<string>();
        this.ciudades = new Array<CiudadEntity>();
        this.datosSiniestro.ciudadPoliza = "";
        this.datosSiniestro.ciudadOcurrencia = "";
    }
    ngOnInit() {
        this.utilsService.getCiudadMasivos().subscribe(
            result => {
                this.ciudades = result;
            },
            error => {
                this.handleError.redirectUrl(error)
            }
        );
    }
    set dateS(e) {
        this.datosSiniestro.fechaSiniestro = new Date(e);
    }

    get dateS() {
        if (this.datosSiniestro.fechaSiniestro != undefined) {
            try {
                var a = this.datosSiniestro.fechaSiniestro.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                var a = this.datosSiniestro.fechaSiniestro.toString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }
    danioSufrido(tipo: number) {
        this.datosSiniestro.amparo = tipo.toString();
    }
    reportarSiniestro() {
        this.showLoader2 = "sk-loading";
        let fechaSin = this.datosSiniestro.fechaSiniestro;
        let fechaReal = new Date(fechaSin.getFullYear(),fechaSin.getMonth(),fechaSin.getDate());
        this.datosSiniestro.fechaSiniestro = fechaReal;
        this.datosSiniestro.poliza = "";
        this.datosSiniestro.unidad = this.vehiculo.CodUnidad.toString();
        this.datosSiniestro.codigoCliente = this.vehiculo.CodCliente.toString();
        this.datosSiniestro.segmento = "2";
        this.datosSiniestro.medioReporte = 25;
        this.datosSiniestro.codigoAseguradora = this.vehiculo.CodAseguradora;
        this.datosSiniestro.codigoProducto = this.vehiculo.CodProducto.toString();
        this.datosSiniestro.codigoBien = this.vehiculo.CodVehiculo.toString();
        this.datosSiniestro.anio = 0;
        this.datosSiniestro.codigoCiudadReparacion  = 0;
        this.datosSiniestro.idContacto = 0;
        this.datosSiniestro.idTaller = 9999;
        this.datosSiniestro.numeroReporte = "";
        this.datosSiniestro.placa = this.vehiculo.Placa.trim();
        this.datosSiniestro.ciudadOcurrencia = this.datosSiniestro.ciudadOcurrencia.trim(); 
        this.datosSiniestro.nombreContacto = this.datosSiniestro.nombreConductor;
        this.datosSiniestro.ciudadPoliza = this.vehiculo.CiuCod.toString();
        this.utilsService.getTieneONoDeducible(this.vehiculo.CiuCod, this.vehiculo.CodCliente).subscribe(
            result => {
                let banderaDeducible = false;
                if(result == true){
                    banderaDeducible = true;
                }
                this.datosSiniestro.tieneDeducible = banderaDeducible;
                this.siniestrosService.ReportarSiniestroVehiculos(this.datosSiniestro).subscribe(
                    result => {
                        this.showLoader2 = "";
                        if (result.estado == 1) {
                            swal({
                                title: 'Reporte de siniestro Vehicular',
                                text: "Tu siniestro ha sido reportado exitosamente, el número de siniestro generado es: " + result.numeroSiniestro,
                                type: 'success'
                            }).then(function(){
                                window.location.reload();
                            });
                        } else {
                            swal({
                                title: 'Reporte de siniestro Vehicular',
                                text: "Ocurrio un problema al reportar tu siniestro, por favor comunicate con nuestro 1800 TuAyuda o con tu ejecutivo de siniestros. Disculpa este inconveniente",
                                type: 'error'
                            });
                        }
                    },
                    error => {
                        this.handleError.redirectUrl(error);
                    }
                );
            },
            error => {
                this.handleError.redirectUrl(error);
            }
        );
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/siniestros/reporteSiniestros/siniestro-reporte-vehiculo.component.ts